import { z } from 'zod';
import type { Integration_Keys } from '@/lib/api/types/integrations';

export const integrationSearchSchema = z.object({
  integration: z.custom<Integration_Keys>().optional(),
  oauthCredentialsId: z.number().optional(),
});
